import FILTER_TYPES from './filter-types';

export const CUSTOM_FIELD_RESOURCES = {
    contacts: 'contacts',
    customers: 'customers',
    paymentCards: 'payment-cards',
    products: 'products',
    subscriptions: 'subscriptions',
    transactions: 'transactions',
    websites: 'websites',
};

const CustomFieldTypes = {
    array: 'array',
    boolean: 'boolean',
    date: 'date',
    datetime: 'datetime',
    integer: 'integer',
    monetary: 'monetary',
    number: 'number',
    string: 'string',
};

export function customFieldToFilterType(type) {
    const map = {
        [CustomFieldTypes.array]: FILTER_TYPES.text,
        [CustomFieldTypes.boolean]: FILTER_TYPES.boolean,
        [CustomFieldTypes.date]: FILTER_TYPES.date,
        [CustomFieldTypes.datetime]: FILTER_TYPES.datetime,
        [CustomFieldTypes.integer]: FILTER_TYPES.numeric,
        [CustomFieldTypes.number]: FILTER_TYPES.numeric,
        [CustomFieldTypes.string]: FILTER_TYPES.text,
        [CustomFieldTypes.monetary]: FILTER_TYPES.numeric,
    };
    return map[type] || FILTER_TYPES.text;
}
